<script setup lang="ts">
import step1DesktopImage from '@consumer/assets/images/how-giftly-works-landing-step-1-desktop.png'
import step1MobileImage from '@consumer/assets/images/how-giftly-works-landing-step-1-mobile.png'
import step2DesktopImage from '@consumer/assets/images/how-giftly-works-landing-step-2-desktop.png'
import step2MobileImage from '@consumer/assets/images/how-giftly-works-landing-step-2-mobile.png'
import step3DesktopImage from '@consumer/assets/images/how-giftly-works-landing-step-3-desktop.png'
import step3MobileImage from '@consumer/assets/images/how-giftly-works-landing-step-3-mobile.png'
import BusinessLogos from '@consumer/modules/shared/BusinessLogos.vue'
import CustomerTestimonials2 from '@consumer/modules/shared/CustomerTestimonials2.vue'
</script>

<template>
  <div class="w-full max-w-screen-lg lg:px-6 mx-auto text-left space-y-10 lg:space-y-16">
    <h1 class="px-6 lg:px-0">
      A Giftly is more than<br>
      <span class="text-grey-700">a gift card</span>
    </h1>

    <div class="bg-white pt-8 pb-16 px-8 lg:py-16 lg:px-12 flex flex-col gap-8 lg:gap-16 rounded-v2sm">
      <div class="w-full flex flex-col lg:flex-row">
        <picture class="w-full lg:h-300px lg:w-450px shrink-0" style="margin: -2% 0 0 -2%;">
          <source media="(min-width: 1024px)" :srcset="step1DesktopImage">
          <img :src="step1MobileImage" height="210" class="object-contain w-full lg:h-full">
        </picture>
        <div class="flex flex-col lg:justify-center lg:ml-20">
          <h2 class="text-xs lg:text-base font-semibold text-grey-700 mb-2">Step 1</h2>
          <h3 class="text-xl lg:text-3xl">You Send</h3>

          <p class="mt-4 text-sm lg:text-lg text-grey-700">
            Send up to $1,000. Delivered via a customized greeting card with thoughtful suggestions
            by email, text, mail, or printout.
          </p>
        </div>
      </div>

      <div class="w-full flex flex-col lg:flex-row-reverse">
        <picture class="w-full lg:h-400px lg:w-460px shrink-0" style="margin: -3% -2% -7% 0;">
          <source media="(min-width: 1024px)" :srcset="step2DesktopImage">
          <img :src="step2MobileImage" height="234" class="object-contain w-full lg:h-full">
        </picture>
        <div class="flex flex-col lg:justify-center mr-20">
          <h2 class="text-xs lg:text-base font-semibold text-grey-700 mb-2">Step 2</h2>
          <h3 class="text-xl lg:text-3xl">They Receive</h3>

          <p class="mt-4 text-sm lg:text-lg text-grey-700">
            The recipient chooses the most convenient way to receive the gift:
            as a physical or digital Visa® or Mastercard® prepaid gift card or as a credit to their
            bank account or PayPal account.
          </p>
        </div>
      </div>

      <div class="w-full flex flex-col lg:flex-row gap-4 lg:gap-0">
        <picture class="w-full lg:h-320px shrink-0">
          <source media="(min-width: 1024px)" :srcset="step3DesktopImage">
          <img :src="step3MobileImage" height="234" class="object-contain w-full lg:h-full">
        </picture>
        <div class="flex flex-col lg:justify-center ml-20">
          <h2 class="text-xs lg:text-base font-semibold text-grey-700 mb-2">Step 3</h2>
          <h3 class="text-xl lg:text-3xl">They Get Exactly What<br>They Want</h3>

          <p class="mt-4 text-sm lg:text-lg text-grey-700">
            The recipient will appreciate your suggestions and the flexibility to get exactly
            what they want with the gifted funds. They'll love it. They may even send you a thank you card 😉
          </p>
        </div>
      </div>
    </div>

    <div class="bg-white p-10 lg:py-16 lg:px-12 flex flex-col gap-16 rounded-v2sm">
      <BusinessLogos/>

      <CustomerTestimonials2/>
    </div>
  </div>
</template>
